import apiClient from './api';

class RecommendationService {
    /**
     * Get product recommendations for a specific product
     * Returns { related: [], best_deals: [] }
     */
    static async getProductRecommendations(productId) {
        try {
            const response = await apiClient.get(`/recommendations/${productId}`);
            return { 
                success: true, 
                related: response.data.related || [],
                best_deals: response.data.best_deals || [],
                personalized: response.data.personalized || []
            };
        } catch (error) {
            console.error('Error fetching product recommendations:', error);
            return { 
                success: false, 
                error: error.message,
                related: [],
                best_deals: [],
                personalized: []
            };
        }
    }

    static async getPersonalizedRecommendations(limit = 5) {
        try {
            const response = await apiClient.get(`/recommendations/personal?limit=${limit}`);
            return { success: true, products: response.data };
        } catch (error) {
            console.error('Error fetching personalized recommendations:', error);
            return { success: false, error: error.message };
        }
    }

    static async getTrendingProducts(limit = 5) {
        try {
            const response = await apiClient.get(`/products?limit=${limit}&is_trending=true`);
            return { success: true, products: response.data.items || [] };
        } catch (error) {
            console.error('Error fetching trending products:', error);
            return { success: false, error: error.message };
        }
    }

    /**
     * Similar products for a SKU — reuses hybrid recommendations' `related` list.
     * Matches shape expected by RecommendedProducts: { success, products }.
     */
    static async getSimilarProducts(productId, limit = 4) {
        const result = await this.getProductRecommendations(productId);
        if (!result.success) {
            return { success: false, error: result.error, products: [] };
        }
        const related = result.related || [];
        return {
            success: true,
            products: related.slice(0, Math.max(0, Number(limit) || 4)),
        };
    }
}

export default RecommendationService;
